import { USER_STORAGE } from './storageConfig'
import { User } from '../contexts/AuthContext'

export function storageUserSave (user: User) {
  localStorage.setItem(USER_STORAGE, JSON.stringify(user))
}

export function storageUserGet () {
  const storage = localStorage.getItem(USER_STORAGE)

  const user: User = storage ? JSON.parse(storage) : null

  return user
}

export function storageUserRemove () {
  localStorage.removeItem(USER_STORAGE)
}

export function storageUserChangeImagePath (newImagePath: string) {
  const storage = localStorage.getItem(USER_STORAGE)
  const user: User = storage ? JSON.parse(storage) : null
  user.imagePath = newImagePath
  localStorage.setItem(USER_STORAGE, JSON.stringify(user))
}
